import { Sort } from './sort';
import { deserialize, object, serializable } from 'serializr';
import { Deserializable } from './deserializable';

export class Pageable implements Deserializable {
  @serializable(object(Sort))
  public sort: Sort;
  @serializable
  public offset: number;
  @serializable
  public pageNumber: number;
  @serializable
  public pageSize: number;
  @serializable
  public paged: boolean;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(Pageable, input));
  }
}
